import { TemplateResponseDto } from './types';
import { getTemplatesUrl } from './urls';

import {
  HsmBackendHttpClient,
  HsmBackendResponseList,
} from '@/utils/http-client';

/**
 * Retrieves templates for a website from the Technical Solutions API.
 *
 * @param websiteId The external website identifier.
 * @returns A promise that resolves to an array of TemplateResponseDto objects.
 */
export async function getTemplates(
  websiteId: string
): Promise<TemplateResponseDto[]> {
  const client = HsmBackendHttpClient.instance;

  const { result: templates } = await client.get<
    HsmBackendResponseList<TemplateResponseDto>
  >(getTemplatesUrl(websiteId));

  return templates;
}
